import { useTranslation } from 'i18n';
import { Instruction, List, ListItem, Skeleton, Typography } from 'ui';

import { useAllDealLoads } from '../../hooks/useAllDealLoads/useAllDealLoads';
import { LoadListItem } from '../LoadListItem/LoadListItem';

const Loader = () => (
  <>
    {Array.from(Array(3)).map((_, index) => (
      <ListItem key={index}>
        <Skeleton
          key={index}
          variant="rectangular"
          sx={{
            width: 300,
            height: 30,
          }}
        />
      </ListItem>
    ))}
  </>
);

export const DealLoads = ({ dealId }: { dealId: number }) => {
  const { t } = useTranslation('orders');
  const { data, isFetching } = useAllDealLoads(dealId);

  if (!isFetching && !data?.results.length) {
    return <Instruction>{t('inspectionLoad.dealLoads.empty')}</Instruction>;
  }

  return (
    <div>
      <Typography variant="h6">{t('inspectionLoad.dealLoads.title')}</Typography>
      <List disablePadding>
        {isFetching ? <Loader /> : null}

        {!isFetching && data?.results.map((load) => <LoadListItem key={load.id} load={load} />)}
      </List>
    </div>
  );
};
